<form #cgvForm="ngForm" class="col-8 col-lg-8 col-sm-12 col-mx-auto card">
    <ngx-extended-pdf-viewer
    id="pdfViewer"
    useBrowserLocale="true"
    [src]="this.pathCGV"
    [height]="'80vh'"
    [textLayer]="true"
    [showHandToolButton]="true"
    [showOpenFileButton]="false"
    [showRotateButton]="false"
    [showSecondaryToolbarButton]="false"
    [showSidebarButton]="false"
    [showStampEditor]="false"
    [showDrawEditor]="false"
    [showFindButton]="false"
    [zoom]="'100'"
    [handTool]="'hand tool'"
    [showHandToolButton]="false"
>

</ngx-extended-pdf-viewer>

    <div class="card-body" *ngIf="!contextService.fullContext.customer?.hasValidatedTerms">
        <div class="form-group">
        <label class="form-checkbox">
            <input type="checkbox" name="cgv" [ngModel]="hasValidatedTermsOfService" #cgv="ngModel" required/>
            <i class="form-icon"></i> Accepter les CGV
        </label>
        </div>
        <button class="btn btn-primary btn-block" type="button" [disabled]="!cgv.value" (click)="validateCGVByGuid()">Valider</button>
    </div>
</form>